var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheTopBar',{attrs:{"controls":_vm.controls,"with-fullscreen-button":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }